/**
 * @deprecated use shared-utils instead
 */
export function isProductionEnv(): boolean {
  return 'production' === window._env_.NODE_ENV;
}
